import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, UntypedFormGroup, ValidationErrors, Validator } from '@angular/forms';
import { Observable } from 'rxjs';

@Directive({
    selector: '[uflaUniqueValue]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UniqueValueDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class UniqueValueDirective implements Validator {

  @Input() uflaUniqueValue: string[] = [];

  constructor() {
  }

  validate(formGroup: UntypedFormGroup): Observable<ValidationErrors | null> | ValidationErrors {
      return this.unique(this.uflaUniqueValue)(formGroup);
  }

  private unique(controlNames: string[]) {
      return (formGroup: UntypedFormGroup) => {
          const controls = controlNames.map(controlName => formGroup.controls[controlName]);

          if (controls.length === 0 || controls.findIndex(value => value === null || value === undefined) !== -1) {
              return null;
          }

          controls.forEach((control) => {
              control.setErrors(null);
          });

          const uniq: {
        [value: string]: AbstractControl[]
      } = controls
          .map(control => {
              return {
                  value: control.value,
                  control,
              };
          }).reduce((a, b) => {
              a[b.value] = (a[b.value] || []).concat(b.control);
              return a;
          }, {});

          const duplicates = Object.keys(uniq)
              .filter(value => !(value === 'undefined' || value === '' || value === 'null'))
              .filter(value => uniq[value].length > 1)
              .map(value => uniq[value])
      ;

          duplicates.forEach(duplicatedControls => {
              duplicatedControls.forEach((control) => {
                  control.setErrors({ uniqueValue: true });
              });
          });
      };
  }

}
